import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 retrieve_promotions_list: { message: "idle" },
};

export const retrieve_promotions_list_Slice = createSlice({
 name: "retrieve_promotions_list",
 initialState,
 reducers: {
  success_retrieve_promotions_list: (state, action) => {
   state.retrieve_promotions_list = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_retrieve_promotions_list: (state, action) => {
   state.retrieve_promotions_list = { status: app_consts.FAIL, message: action.payload };
  },
  reset_retrieve_promotions_list: (state) => {
   state.retrieve_promotions_list = { status: app_consts.IDLE };
  },
  loading_retrieve_promotions_list: (state) => {
   state.retrieve_promotions_list = { status: app_consts.LOADING };
  },
 }
});

export const { success_retrieve_promotions_list, fail_retrieve_promotions_list, reset_retrieve_promotions_list, loading_retrieve_promotions_list } = retrieve_promotions_list_Slice.actions;

export default retrieve_promotions_list_Slice.reducer;